module.exports = __webpack_public_path__ + "img/photo.6d104194.png";